const awsconfig = {
  /* eslint-disable camelcase */
  aws_project_region: "ap-northeast-1",
  aws_cognito_identity_pool_id: "",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_hsFA7UMjh",
  aws_user_pools_web_client_id: "5jmqcm9ge8slnu7eejmojde76a",
  oauth: {},
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["email"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["email"],
  aws_cognito_mfa_configuration: "ON",
  aws_cognito_mfa_types: ["TOTP"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["email"],
  // 必要な属性設定を追加
  aws_cognito_user_attributes: {
    name: {
      required: false,
      mutable: true,
    },
    email: {
      required: true,
      mutable: true,
    },
  },
  /* eslint-enable camelcase */
};

export default awsconfig;
